import { z } from 'zod';

const campaignTypeSchema = z.object({
  typeId: z.string().nullable(),
  order: z.number().int().positive(),
  campaignType: z.string().min(1, 'Tipo de campanha é obrigatório'),
  campaignsName: z.array(z.string()).optional(),
});

const campaignPromotionsformSchema = z.object({
  campaignTypes: z.array(campaignTypeSchema).min(1, 'Adicione pelo menos um tipo de campanha').max(5, 'Adicione no máximo 5 tipos de campanha'),
  campaignPrioritization: z.enum(['PRIORITY_TYPE', 'PRICE_LOWER']),
  campaignOfferEditing: z.enum(['ALLOW_EDITING', 'DO_NOT_ALLOW_EDITING']),
});

type CampaignPromotionsType = z.infer<typeof campaignPromotionsformSchema>;
type CampaignType = z.infer<typeof campaignTypeSchema>;
type CampaignTypeWithIndex = z.infer<typeof campaignTypeSchema> & { index: number };

export { campaignPromotionsformSchema, type CampaignPromotionsType, type CampaignType, type CampaignTypeWithIndex };
